import { Container, Divider, Typography } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  CurrencyDisplay,
  CustomTable,
  FormLabel,
  ModalError,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  StatusChip,
  SwitchInput,
} from "components";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatDate, getErrors, textCapitalization } from "utils";
import {
  columnTableInvoiceSongDetail,
  optionsStatusComposerPayment,
} from "../../../Publisher/Invoice/Components/ConstantInvoice";

const PenciptaDetailPayment = ({ userLogin }) => {
  const classes = globalStyles();
  const { id } = useParams();
  const inputRef = useRef(null);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [pageDetail, setPageDetail] = useState({});
  const [showDetail, setShowDetail] = useState(false);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
  });
  const selectedStatus = optionsStatusComposerPayment?.find(
    item => item?.value === pageDetail?.status
  );
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const approvalStatus = pageDetail?.status;
  const hideColumnRemainingRevenue =
    approvalStatus === "paid" || approvalStatus === "processed";

  const handlePrintPDF = () => {
    html2canvas(inputRef.current, { useCORS: true }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "px", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("download.pdf");
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/transaction/v2/payment/${id}`,
        { headers, params: queryParams }
      );
      const { data } = res?.data || {};
      const pageCount = getTotalPage(
        data?.sales_invoices?.total,
        queryParams?.size
      );
      setTableTotalPage(pageCount || 1);
      setPageDetail(data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  useEffect(() => {
    getDetail();
  }, [queryParams]);

  return (
    <Page className={classes.root} title="Payment Detail">
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title="Payment Transaction"
            breadcrumbData={breadcrumbData}
            backButton
          />
          <Divider className={classes.divider} />
          <Grid container justifyContent="space-between">
            <Grid item>
              <SectionLabel
                title="Payment Detail"
                subTitle="This is detail credit note information, in payment transaction"
              />
            </Grid>
            <Grid item>
              <StatusChip
                label={
                  selectedStatus?.name || textCapitalization(pageDetail?.status)
                }
                type={selectedStatus?.color}
              />
            </Grid>
          </Grid>
          <Box
            border="1px solid #ebebeb"
            borderRadius="5px"
            p="24px"
            my="16px"
            ref={inputRef}
          >
            <Grid container justifyContent="space-between">
              <Grid item xs={12} md={6}>
                <img
                  src={userLogin?.publisher?.profile_image}
                  alt="img"
                  height="50px"
                />
              </Grid>
              <Grid item xs={12} md={6} textAlign="right">
                <FormLabel label={pageDetail?.publisher_name} />
                <SectionLabel subTitle={pageDetail?.publisher_address} />
              </Grid>
            </Grid>
            <Divider className={classes?.divider} />
            <Grid container columnSpacing={1}>
              <Grid item xs={12} md={6}>
                <Typography>Request Payment to:</Typography>
                <FormLabel label={pageDetail?.publisher_name} />
              </Grid>
              <Grid item xs={12} md={6}>
                {mockfieldForm?.map(({ label, key, type }, index) => (
                  <Grid container justifyContent="space-between" key={index}>
                    <Grid item>{label}</Grid>
                    <Grid item textAlign="right">
                      {type === "currency" ? (
                        <CurrencyDisplay
                          decimalScale={2}
                          prefix="Rp"
                          value={pageDetail?.[key] || 0}
                        />
                      ) : type === "date" ? (
                        formatDate(pageDetail?.[key])
                      ) : (
                        pageDetail?.[key]
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Divider className={classes?.divider} />
            <FormLabel label="Notes:" />
            <Typography>{pageDetail?.notes}</Typography>
            <Box mt="16px" className="hideWhenPrint">
              <SwitchInput
                checked={showDetail}
                onChange={() => setShowDetail(show => !show)}
                label="Show Song Detail"
              />
            </Box>
            {showDetail && (
              <CustomTable
                columnTable={columnTableInvoiceSongDetail({
                  hideColumnRemainingRevenue,
                  paymentComposer: true,
                  hideSalesInvoiceNo: true,
                })}
                data={pageDetail?.sales_invoices?.data}
                page={queryParams?.page}
                pageSize={queryParams?.size}
                pageCount={tableTotalPage}
                handleChangePage={(_, page) =>
                  handleChangeQueryParams(page, "page")
                }
                handleChangePageSize={e =>
                  handleChangeQueryParams(e?.target?.value, "size")
                }
                my="16px"
              />
            )}
            <Box bgcolor="#f2f2f2" borderRadius="5px" p="16px" my="16px">
              <Grid container justifyContent="space-between">
                <Grid item>Value</Grid>
                <Grid item>
                  <CurrencyDisplay
                    decimalScale={2}
                    prefix="Rp"
                    value={pageDetail?.value}
                    fontWeight={600}
                  />
                </Grid>
              </Grid>
              <Divider className={classes?.divider} />
              {Boolean(pageDetail?.selected_taxes?.length) && (
                <Box>
                  {pageDetail?.selected_taxes?.map((tax, index) => (
                    <Grid container justifyContent="space-between" key={index}>
                      <Grid
                        item
                      >{`${tax?.code} ${tax?.rate}% (${tax?.method})`}</Grid>
                      <Grid item>
                        <CurrencyDisplay
                          decimalScale={2}
                          prefix="Rp"
                          value={tax?.value}
                          fontWeight={600}
                        />
                      </Grid>
                    </Grid>
                  ))}
                  <Divider className={classes?.divider} />
                </Box>
              )}
              {pageDetail?.transaction_payment_detail?.cost_allocation &&
                pageDetail?.transaction_payment_detail?.cost_allocation
                  .cost_allocation_percentage && (
                  <Box>
                    <Grid container justifyContent="space-between">
                      <Grid
                        item
                      >{`Cost Allocation ${pageDetail?.transaction_payment_detail?.cost_allocation.cost_allocation_percentage}`}</Grid>
                      <Grid item>
                        <CurrencyDisplay
                          decimalScale={2}
                          prefix="Rp"
                          value={
                            pageDetail?.transaction_payment_detail
                              .cost_allocation
                          }
                          fontWeight={600}
                        />
                      </Grid>
                    </Grid>
                    <Divider className={classes?.divider} />
                  </Box>
                )}
              {Boolean(
                pageDetail?.transaction_payment_detail?.agent_fee?.length
              ) && (
                <Box>
                  {pageDetail?.transaction_payment_detail?.agent_fee?.length?.map(
                    (agent, index) => (
                      <Grid
                        container
                        justifyContent="space-between"
                        key={index}
                      >
                        <Grid
                          item
                        >{`Agent Fee (${agent?.agent_percentage}%)`}</Grid>
                        <Grid item>
                          <CurrencyDisplay
                            decimalScale={2}
                            prefix="Rp"
                            value={agent?.agent_value}
                          />
                        </Grid>
                      </Grid>
                    )
                  )}
                  <Divider className={classes?.divider} />
                </Box>
              )}

              <Grid container justifyContent="space-between">
                <Grid item>Total Value</Grid>
                <Grid item>
                  <CurrencyDisplay
                    decimalScale={2}
                    prefix="Rp"
                    value={pageDetail?.value_with_tax}
                    fontWeight={600}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
          {pageDetail?.status === "paid" && (
            <Grid container justifyContent="right" columnSpacing={1}>
              <PrimaryButton label="Download As PDF" onClick={handlePrintPDF} />
            </Grid>
          )}
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = [
  {
    label: "Home",
    link: "/pencipta/dashboard-pencipta",
  },
  {
    label: "Transaction",
    link: "/pencipta/payment",
  },
  {
    label: "Payment",
    link: "/pencipta/payment",
  },
  {
    label: "Payment Detail",
    active: true,
  },
];
const mockfieldForm = [
  { label: "Date:", key: "invoice_date", type: "date" },
  { label: "Payment No:", key: "invoice_number" },
  { label: "Composer:", key: "composer_name" },
  { label: "Value", key: "value", type: "currency" },
  { label: "Remaining Balance", key: "remaining_balance", type: "currency" },
];

export default PenciptaDetailPayment;
